// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__3WEm8","rootCenter":"LoadMoreObserver_rootCenter__35h-q","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__CH1Lz"};